import React from "react";
import { Grid, GridProps } from "@material-ui/core";

export const GridFlexDown = ({ children }: GridProps) => (
  <Grid xs={4} container item direction="column" justifyContent="flex-end">
    {children}
  </Grid>
);
